<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>    

    <v-tabs-items
      v-model="active"
      style="background:transparent"
    >
      <v-tab-item>
        <v-autocomplete
          v-model="employeeReport"
          label="Report Types"
          :items="reportTypes"
          item-text="name"
          class="pt-5 px-3"
          autofocus
          style="background:white"
        />
        <report-employee-basic-information
          v-if="employeeReport === 'Head Count'"
          class="mb-2"
        />
        <report-employee-details-information
          v-if="employeeReport === 'Employee Details'"
          class="mb-2"
        />
        <report-employee-family-details
          v-if="employeeReport === 'Family Details'"
          class="mb-2"
        />        
        <report-employee-movements
          v-if="employeeReport === 'Movements'"
          class="mb-2"
        />
        <report-employee-disciplinary
          v-if="employeeReport === 'Disciplinary'"
          class="mb-2"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>      
</template>

<script>
  export default {
    components: {
      ReportEmployeeBasicInformation: () => import('@/components/hris/reports/employee/BasicInformation'),
      ReportEmployeeDetailsInformation: () => import('@/components/hris/reports/employee/DetailsInformation'),
      ReportEmployeeFamilyDetails: () => import('@/components/hris/reports/employee/FamilyDetails'),
      ReportEmployeeMovements: () => import('@/components/hris/reports/employee/Movements'),
      ReportEmployeeDisciplinary: () => import('@/components/hris/reports/employee/Disciplinary'),
    },

    data () {
      return {
        tabItems: [
          { name: 'Employee Reports' },
        ],
        active: 0,
        employeeReport: null,
        reportTypes: [
          ...(this.$hasPermissionTo(['generate head count report']) ? [{ name: 'Head Count' }] : []),
          ...(this.$hasPermissionTo(['generate employee details report']) ? [{ name: 'Employee Details' }] : []),
          ...(this.$hasPermissionTo(['generate family details report']) ? [{ name: 'Family Details' }] : []),
          ...(this.$hasPermissionTo(['generate employee movements report']) ? [{ name: 'Movements' }] : []),
          ...(this.$hasPermissionTo(['generate disciplinary report']) ? [{ name: 'Disciplinary' }] : []),
        ],
      }
    },
  }
</script>
